import * as React from 'react';
import { cornerRadiusXL } from '@xingternal/tokens';
import * as Styled from './skeleton-card.styles';
export const SkeletonCard = ({ children, className, noPadding, ...props }) => (React.createElement(Styled.Card, { "$noPadding": noPadding, children: children, className: className, cornerRadius: cornerRadiusXL, "data-xds": "SkeletonCard", variant: "outline", ...props }));
SkeletonCard.displayName = 'SkeletonCard';
//# sourceMappingURL=skeleton-card.js.map